import React from 'react';
import ReactDOM from 'react-dom';
import {
  browserHistory,
  IndexRoute,
  Redirect,
  Route,
  Router,
} from 'react-router';


import Base from './pages/Base';
import Home from './pages/home/Home';
import Offers from './pages/offers/Offers';
import Products from './pages/products/Products';
import Reviews from './pages/reviews/Reviews';
import Photos from './pages/photos/Photos';

require('./styles/app.scss');

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/:partnerSlug" component={Base}>
      <IndexRoute component={Home} />

      <Redirect from="/:partnerSlug/products" to="/:partnerSlug/products/1" />
      <Route path="/:partnerSlug/products" component={Products}>
        <Route path="/:partnerSlug/products/:pageId" component={Products} />
      </Route>

      <Redirect from="/:partnerSlug/offers" to="/:partnerSlug/offers/1" />
      <Route path="/:partnerSlug/offers" component={Offers}>
        <Route path="/:partnerSlug/offers/:pageId" component={Offers} />
      </Route>

      <Redirect from="/:partnerSlug/reviews" to="/:partnerSlug/reviews/1" />
      <Route path="/:partnerSlug/reviews" component={Reviews}>
        <Route path="/:partnerSlug/reviews/:pageId" component={Reviews} />
      </Route>

      <Route path="/:partnerSlug/photos" component={Photos} />
    </Route>
  </Router>, document.getElementById('app'));



// WEBPACK FOOTER //
// ./app/index.jsx